import { Image } from "antd";

type Item = { src: string; caption: string };

type Props = {
    items: Item[];
};

// Horizontal scroll-snap carousel of phone screenshots. Each item is
// figure + figcaption so the caption is programmatically associated with
// the image for screen readers.
export default function ScreenshotCarousel({ items }: Props) {
    return (
        <div
            className="gt-screenshot-carousel"
            role="region"
            aria-label="Product screenshots"
        >
            <Image.PreviewGroup>
                {items.map((s) => (
                    <figure key={s.src} className="gt-screenshot-carousel__item">
                        <div className="gt-screenshot-carousel__frame">
                            <Image
                                src={s.src}
                                alt={s.caption}
                                width={220}
                                style={{
                                    display: "block",
                                    width: "100%",
                                    height: "auto",
                                    // Reserve the box before the image loads
                                    // so the carousel doesn't shift (CLS).
                                    // All screenshots are 600×1115.
                                    aspectRatio: "600 / 1115",
                                }}
                            />
                        </div>
                        <figcaption className="gt-screenshot-carousel__caption">
                            {s.caption}
                        </figcaption>
                    </figure>
                ))}
            </Image.PreviewGroup>
        </div>
    );
}
